import React from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const NothingToShow = () => {
    const { formatMessage } = useIntl()

    return (
        <div className='w-100 h-100 bg-white d-flex align-items-center justify-content-center rounded-2 py-8' style={{ padding: '100px 0' }}>
            <div className='text-center d-flex flex-column'>
                <div>
                    <img src={toAbsoluteUrl('/media/icons/investor-updates/NoDataImg.svg')} alt='no-data-img' height={125}
                        width={125} />
                </div>
                <div className='w-100'>

                    <h1 className='fs-5'>{formatMessage({ id: 'Nothing To Show' })}</h1>

                    <p className='w-100 fs-8 mb-0'>
                        {formatMessage({
                            id: `Currently we don't have anything`,
                        })}
                    </p>
                    <p className='w-100 fs-8 mb-0'>
                        {formatMessage({
                            id: `to show here`,
                        })}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default NothingToShow
